export default "__VITE_ASSET__CD2M_jcI__"